<div class="mb-3">
  <h6>{{header}}</h6>
</div>
<div class="row">
  <div class="col-md-6">
    <app-form-group label="Early deadline time">
      <app-duration [(ngModel)]="deadlines.earlyDeadlineTime"></app-duration>
    </app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Pilot or Tugboat deadline">
      <app-duration [(ngModel)]="deadlines.pilotOrTugboatDeadline"></app-duration>
    </app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Boatmen deadline">
      <app-duration [(ngModel)]="deadlines.boatmenDeadline"></app-duration>
    </app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Helmsmen">
      <app-duration [(ngModel)]="deadlines.helmsmenDeadline"></app-duration>
    </app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group label="Default deadline">
      <app-duration [(ngModel)]="deadlines.defaultDeadline"></app-duration>
    </app-form-group>
  </div>
</div>
